import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  CCard,
  CButton,
  CCardBody,
  CCardHeader,
  CRow,
  CCol,
  CDropdown,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CModalTitle,
  CPopover,
  CTabs,
  CNav,
  CNavItem,
  CNavLink
} from "@coreui/react";
import axios from "../../../../config/axios";
import { toastr } from "react-redux-toastr";
import FileSaver from "file-saver";

// import { saveAs } from "file-saver";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";

import PermissionFileModal from "./permission";
import EditFileModal from "./edit";
import UploadModal from "./upload";
import FolderModal from "./folder";
import InfoModal from "./info";
import { setObj } from "../../../../actions/noteActions";
import Interface from "../../../../components/Interface";
import URL from "../../../../config/api";
import Loading from "../../../../components/Loading";
import Breadcrumb from "../../../../components/Breadcrumb";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import "./style.css";

class DocsMe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      docs: [],
      doc_id: null,
      selected: null,
      tab: 1,
      iframe: false,
      title: null,
      url: null,
      folderModal: false,
      infoModal: false,
      uploadModal: false,
      contextMenu: true,
      editModal: false,
      deleteModal: false,
      permissionModal: false,
      shared: false
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.updateDocs();
  }

  openUrl(title, url) {    
    this.setState({
      iframe: true,
      url: url,
      title: title
    });
  }

  download(fileSelected) {
    var url = fileSelected.link;
    var a = parseInt(url.length);
    var b = parseInt(url.lastIndexOf("/"));
    var c = a - b;
    var name = url.substring(url.length - c + 1);
    FileSaver.saveAs(url, name);
  }

  updateDocs() {
    axios
      .post(
        URL.api + "content/doc/list",
        { user_id: this.props.user.user.id, shared: this.state.shared },
        { headers: { Authorization: "Bearer " + this.props.user.token } }
      )
      .then(
        resp => {
          this.setState({ docs: resp.data.data, loading: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  setMine() {
    this.setState({ shared: false, doc_id: null, loading: true }, () => {
      this.updateDocs();
    });
  }

  setShared() {
    this.setState({ shared: true, doc_id: null, loading: true }, () => {
      this.updateDocs();
    });
  }

  closeModalFolder(res = null) {
    this.setState({ folderModal: false });
    this.updateDocs();
  }

  closeModalUpload(res = null) {
    this.setState({ uploadModal: false });
    this.updateDocs();
  }

  closeModalEdit() {
    this.setState({ editModal: false });
    this.updateDocs();
  }

  deleteFile(fileSelected) {
    if (
      fileSelected.folder === true &&
      this.state.docs.filter(item => item.doc_id === fileSelected.id).length > 0
    ) {
      this.error("Não é possível apagar uma pasta com arquivos");
      this.setState({ deleteModal: false });
    } else {
      axios
        .post(URL.api + "content/doc/delete/" + this.state.selected, null, {
          headers: { Authorization: "Bearer " + this.props.user.token }
        })
        .then(
          resp => {
            if (resp.data.success) {
              this.setState({ deleteModal: false });
              this.updateDocs();
            } else this.error(resp.data.error);
          },
          error => {
            this.error(error.response.statusText);
          }
        );
    }
  }

  render() {
    const fileSelected = this.state.docs.find(
      item => item.id === this.state.selected
    );

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <div className="docs-me" onContextMenu={e => e.preventDefault()}>
          {/* {this.state.iframe && (
            <Interface
              show={this.state.iframe}
              url={this.state.url}
              title={this.state.title}
              botoes={0}
              onClose={() => this.setState({ iframe: false })}
            />
          )} */}
          <FolderModal
            show={this.state.folderModal}
            doc_id={this.state.doc_id}
            onClose={e => this.closeModalFolder(e)}
          />
          <InfoModal
            show={this.state.infoModal}
            file={this.state.docs.find(item => item.id === this.state.selected)}
            onClose={() => this.setState({ infoModal: false })}
          />
          {this.state.uploadModal && (
            <UploadModal
              doc_id={this.state.doc_id}
              onClose={e => this.closeModalUpload(e)}
            />
          )}
          {this.state.editModal && (
            <EditFileModal
              doc_id={this.state.doc_id}
              onClose={() => this.closeModalEdit()}
              selected={this.state.docs.find(
                item => item.id === this.state.selected
              )}
            />
          )}
          {this.state.permissionModal && (
            <PermissionFileModal
              doc_id={this.state.doc_id}
              onClose={() => this.setState({ permissionModal: false })}
              selected={this.state.docs.find(
                item => item.id === this.state.selected
              )}
            />
          )}
          <CModal
            show={this.state.deleteModal}
            onClose={() => this.setState({ deleteModal: false })}
            closeOnBackdrop={false}
          >
            <CModalHeader closeButton className="bg-danger">
              <CModalTitle>
                Apagar{" "}
                {fileSelected && fileSelected.folder ? "pasta" : "arquivo"}
              </CModalTitle>
            </CModalHeader>
            <CModalBody>
              Deseja apagar{" "}
              {fileSelected && fileSelected.folder
                ? "a pasta selecionada?"
                : "o arquivo selecionado?"}
            </CModalBody>
            <CModalFooter>
              <CButton
                color="danger"
                onClick={() => this.deleteFile(fileSelected)}
              >
                Apagar
              </CButton>{" "}
              <CButton
                color="secondary"
                onClick={() => this.setState({ deleteModal: false })}
              >
                Cancelar
              </CButton>
            </CModalFooter>
          </CModal>
          <CTabs>
            <CNav variant="tabs" className="d-flex mb-4">
              <CNavItem onClick={() => this.setMine()}>
                <CNavLink className="tab-not-focus">
                  <h4
                    className="d-inline-block mr-1 mb-0 p-1"
                    style={!this.state.shared ? { color: "#000000" } : {}}
                  >
                    Meus documentos
                  </h4>
                </CNavLink>
              </CNavItem>
              <CNavItem onClick={() => this.setShared()}>
                <CNavLink className="tab-not-focus">
                  <h4
                    className="d-inline-block mr-1 mb-0 p-1"
                    style={this.state.shared ? { color: "#000000" } : {}}
                  >
                    Compartilhados comigo
                  </h4>
                </CNavLink>
              </CNavItem>
              {!this.state.shared && (
                <div className="flex-1 d-flex justify-content-end align-items-center">
                  <CButton
                    color="secondary"
                    className="mr-2"
                    onClick={() => this.setState({ folderModal: true })}
                  >
                    <i className="fa fa-plus mr-2"></i>Nova pasta
                  </CButton>
                  <CButton
                    color="primary"
                    onClick={() => this.setState({ uploadModal: true })}
                  >
                    <i className="fa fa-cloud-upload mr-2"></i>Upload
                  </CButton>
                </div>
              )}
            </CNav>
          </CTabs>
          {this.state.loading ? (
            <Loading />
          ) : this.state.docs && this.state.docs.length > 0 ? (
            <React.Fragment>
              <CRow>
                {this.state.doc_id !== null && (
                  <CCol md={3} sm={4}>
                    <CCard
                      className={this.state.selected === -1 && "doc-selected"}
                      onClick={() => this.setState({ selected: -1 })}
                      onDoubleClick={() =>
                        this.setState({
                          doc_id: this.state.docs.find(
                            item => item.id === this.state.doc_id
                          ).doc_id
                        })
                      }
                    >
                      <CCardBody
                        style={{ pointerEvents: "none", userSelect: "none" }}
                      >
                        <div className="d-flex align-items-center">
                          <i className="fa fa-folder-open text-muted"></i>
                          <span
                            className="text-ellipsis mx-3"
                            style={{ flex: 1 }}
                          >
                            ..
                          </span>
                        </div>
                      </CCardBody>
                    </CCard>
                  </CCol>
                )}
                {this.state.docs &&
                  this.state.docs
                    .filter(
                      doc =>
                        doc.folder === true && doc.doc_id === this.state.doc_id
                    )
                    .map(doc => (
                      <CCol md={3} sm={4}>
                        <ContextMenuTrigger id="context-menu">
                          <CCard
                            onContextMenu={() =>
                              this.setState({ selected: doc.id })
                            }
                            className={
                              this.state.selected === doc.id && "doc-selected"
                            }
                            onClick={() => this.setState({ selected: doc.id })}
                            onDoubleClick={() =>
                              this.setState({ doc_id: doc.id })
                            }
                          >
                            <CCardBody
                              style={{
                                pointerEvents: "none",
                                userSelect: "none"
                              }}
                            >
                              <div className="d-flex align-items-center">
                                <i className="fa fa-folder text-muted"></i>
                                <span
                                  className="text-ellipsis mx-3"
                                  style={{ flex: 1 }}
                                >
                                  {doc.name}
                                </span>
                                <span className="text-muted">
                                  {
                                    this.state.docs.filter(
                                      item => item.doc_id === doc.id
                                    ).length
                                  }
                                </span>
                              </div>
                            </CCardBody>
                          </CCard>
                        </ContextMenuTrigger>
                      </CCol>
                    ))}
              </CRow>
              <CRow>
                {this.state.docs &&
                  this.state.docs
                    .filter(
                      doc =>
                        doc.folder === false && doc.doc_id === this.state.doc_id
                    )
                    .map(doc => (
                      <CCol md={2} sm={3}>
                        <ContextMenuTrigger id="context-menu">
                          <CPopover content={doc.name} placement="bottom">
                            <CCard
                              onContextMenu={() =>
                                this.setState({ selected: doc.id })
                              }
                              className={
                                this.state.selected === doc.id && "doc-selected"
                              }
                              onClick={() =>
                                this.setState({ selected: doc.id })
                              }
                              onDoubleClick={() => this.download(doc)}
                            >
                              <CCardHeader
                                className="p-0 d-flex justify-content-center align-items-center"
                                style={{
                                  pointerEvents: "none",
                                  userSelect: "none"
                                }}
                              >
                                <i
                                  className="fa fa-file text-danger m-0"
                                  style={{ fontSize: "1.25rem" }}
                                ></i>
                                <div style={{ paddingBottom: "56.25%" }}></div>
                              </CCardHeader>
                              <CCardBody
                                style={{
                                  pointerEvents: "none",
                                  userSelect: "none"
                                }}
                              >
                                <div className="text-ellipsis text-center">
                                  {doc.name}
                                </div>
                              </CCardBody>
                            </CCard>
                          </CPopover>
                        </ContextMenuTrigger>
                      </CCol>
                    ))}
              </CRow>
              <ContextMenu id="context-menu" style={{ zIndex: 1000 }}>
                <CDropdown>
                  <CDropdownMenu className="show">
                    {/* <MenuItem>
                      <CDropdownItem
                        onClick={() =>
                          fileSelected && fileSelected.folder
                            ? this.setState({ doc_id: fileSelected.id })
                            : this.openUrl(fileSelected.name, fileSelected.link)
                        }
                      >
                        <i
                          className={
                            "fa fa-" +
                            (fileSelected && fileSelected.folder
                              ? "folder"
                              : "file") +
                            " mr-2"
                          }
                        ></i>
                        Abrir
                      </CDropdownItem>
                    </MenuItem> */}
                    <MenuItem>
                      <CDropdownItem
                        onClick={() =>
                          fileSelected && this.setState({ infoModal: true })
                        }
                      >
                        <i className="fa fa-info mr-2"></i>Informações
                      </CDropdownItem>
                    </MenuItem>
                    {fileSelected && !fileSelected.folder && (
                      <MenuItem>
                        <CDropdownItem
                          onClick={() => this.download(fileSelected)}
                        >
                          <i className={"fa fa-cloud-download mr-2"}></i>Fazer
                          download
                        </CDropdownItem>
                      </MenuItem>
                    )}
                    {fileSelected && fileSelected.room_id && (
                      <MenuItem>
                        <CDropdownItem
                          to={
                            fileSelected &&
                            "/classroom/" + fileSelected.room_id + "/docs"
                          }
                        >
                          <i className={"fa fa-folder-open mr-2"}></i>Ir para
                          local
                        </CDropdownItem>
                      </MenuItem>
                    )}
                    {fileSelected &&
                      fileSelected.user_id === this.props.user.user.id && (
                        <>
                          <MenuItem>
                            <CDropdownItem
                              onClick={() => this.setState({ editModal: true })}
                            >
                              <i className="fa fa-pencil mr-2"></i>Renomear
                            </CDropdownItem>
                          </MenuItem>
                          <MenuItem>
                            <CDropdownItem
                              onClick={() =>
                                this.setState({ permissionModal: true })
                              }
                            >
                              <i className="fa fa-share-alt mr-2"></i>Alterar
                              permissões
                            </CDropdownItem>
                          </MenuItem>
                          <MenuItem>
                            <CDropdownItem
                              onClick={() =>
                                this.setState({ deleteModal: true })
                              }
                            >
                              <i className="fa fa-trash mr-2"></i>Apagar
                            </CDropdownItem>
                          </MenuItem>
                        </>
                      )}
                  </CDropdownMenu>
                </CDropdown>
              </ContextMenu>
              <ProtectedRoute routeId={this.props.currentRoute} />
            </React.Fragment>
          ) : (
            <div className="d-flex align-items-center justify-content-center m-3">
              Nenhum documento encontrado
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DocsMe);
